<template>
  <div class="line-wrapper">
    <div ref="myLine" class="pie"></div>
  </div>
</template>

<script>
// cleanscore_line_de_fen: 得分// cleanscore_line_da_biao_xian: 达标线// cleanscore_line_jing_jie_xian: 警戒线// cleanscore_line_qing_jie_mian_ji: 清洁面积// cleanscore_line_mu_biao_zhi: 目标值// cleanscore_line_qjsc: 清洁时长(min)// cleanscore_line_mu_biao_zhi_1: 目标值(min)

export default {
  name: 'myLine',
  props: {
    lineType: {
      type: String,
      default: 'cleanScore'
    },
    lineData: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      lineProps: []
    };
  },
  watch: {
    lineData() {
      this.drawLine();
    },
    lineType() {
      this.drawLine();
    }
  },
  mounted: function () {
    this.mergeLanguage(null, 'portal_cleanscore_line');
    this.drawLine();
  },
  methods: {
    i18nCallback() {
      this.drawLine();
    },
    initProps() {
      if (this.lineType === 'cleanScore') {
        this.lineProps = [
          {
            name: this.$t('cleanscore_line_de_fen'),
            code: 'cleanScore',
            color: '#00A0D9'
          },
          {
            name: this.$t('cleanscore_line_da_biao_xian'),
            icon: 'rect',
            code: 'yellowScore',
            color: '#FAC04C'
          },
          {
            name: this.$t('cleanscore_line_jing_jie_xian'),
            icon: 'rect',
            code: 'redScore',
            color: '#EB5A5A'
          }
        ];
      } else if (this.lineType === 'totalCleanArea') {
        this.lineProps = [
          {
            name: `${this.$t('cleanscore_line_qing_jie_mian_ji')}(${this.$formatLenUnit()})`,
            code: 'totalCleanArea',
            color: '#00A0D9'
          },
          {
            name: `${this.$t('cleanscore_line_mu_biao_zhi')}(${this.$formatLenUnit()})`,
            icon: 'rect',
            code: 'goalArea',
            color: '#FAC04C'
          }
        ];
      } else if (this.lineType === 'totalUsageTime') {
        this.lineProps = [
          {
            name: this.$t('cleanscore_line_qjsc'),
            code: 'totalUsageTime',
            color: '#00A0D9'
          },
          {
            name: this.$t('cleanscore_line_mu_biao_zhi_1'),
            icon: 'rect',
            code: 'goalTime',
            color: '#FAC04C'
          }
        ];
      }
    },
    drawLine() {
      this.initProps();
      if (this.myChart) {
        this.myChart.dispose();
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(this.$refs.myLine);
      // 绘制图表
      this.myChart.setOption({
        tooltip: {
          show: true,
          axiosPointer: {
            type: 'line',
          }
        },
        grid: {
          left: 52,
          right: 31
        },
        legend: {
          bottom: 0,
          itemGap: 18,
          data: this.lineProps.map(t => ({
            name: t.name,
            icon: t.icon || undefined,
            textStyle: {
              color: '#1A1A1A',
              fontWeight: 'bold',
              fontSize: 12
            },
            itemStyle: {
              color: t.color || undefined
            }
          }))
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            show: true,
            lineStyle: { color: '#F0F0F0' }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            margin: 10,
            fontSize: 10,
            color: '#818181'
          },
          data: this.lineData.map(t => t.date) // X轴日期
        },
        yAxis: {
          type: 'value',
          name: this.lineProps[0].name,
          nameGap: 24,
          nameTextStyle: {
            color: '#00A0D9',
            lineHeight: 32,
            fontWeight: 'bold',
            align: 'center'
          },
          axisLine: {
            show: true,
            lineStyle: { color: '#F0F0F0' }
          },
          axisLabel: {
            margin: 10,
            fontSize: 10,
            color: '#818181'
          },
          splitLine: {
            show: true,
            lineStyle: { color: '#F0F0F0' }
          }
        },
        series: this.lineProps.map((t, i) => ({
          name: t.name,
          type: 'line',
          data: this.lineData.map(f => f[t.code]),
          showSymbol: i === 0,
          symbolSize: 8,
          symbol: 'circle',
          lineStyle:
            i === 0
              ? {
                color: '#00A0D9',
                with: 3
              }
              : {
                cap: 'butt',
                type: 'solid',
                color: t.color
              },
          areaStyle:
            i === 0
              ? {
                origin: 'start',
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: 'rgba(0, 160, 217, 0.4)' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: 'rgba(0, 160, 217, 0)' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
              : undefined,
          itemStyle:
            i === 0
              ? {
                color: '#00A0D9',
                borderColor: '#ffffff',
                borderWidth: 2,
                borderType: 'solid'
              }
              : undefined
        }))
      }, { notMerge: true });
    }
  }
};
</script>

<style lang="scss">
.line-wrapper {
  height: 410px;
  position: relative;
  .pie {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
}
</style>
